import React, { useState } from 'react';
import { Box, Container, Disclosure, Heading } from '@qga/roo-ui/components';
import BlockContent from '@sanity/block-content-to-react';
import PropTypes from 'prop-types';

import Link from '@/components/Link';
import withProps from '@/components/withProps';
import FaqCategory from '@/propTypes/FaqCategory';
import { useGA4Events } from '@/v2/hooks/featureFlags/ga4Events/useGA4Events';
import dataLayer from '@/v2/utils/dataLayer';

const AllCategories = ({ categories }) => {
  const shouldUseNewEvents = useGA4Events();
  const [questionSlug, setQuestionSlug] = useState();

  return (
    <Box bg="white" py={['9', null, '18']}>
      <Container>
        {categories.map(({ slug, name, faqs }) => (
          <Box key={slug} id={slug} pb={['9', null, '18']}>
            <Heading.h2 textStyle="h3">{name}</Heading.h2>
            {faqs.filter(Boolean).map(({ question, answer }) => (
              <Box
                key={question.slug}
                onClick={() => {
                  if (shouldUseNewEvents && question.slug !== questionSlug) {
                    setQuestionSlug(question.slug);
                    dataLayer.accordionOpenEvent({
                      groupName: 'FAQ Page',
                      itemName: question,
                    });
                  }
                }}
              >
                <Disclosure headerTitle={question.name} expand={false}>
                  <BlockContent
                    blocks={answer}
                    serializers={{
                      marks: {
                        link: withProps(({ mark }) => ({
                          href: mark.href,
                          external: true,
                        }))(Link.Text),
                      },
                    }}
                  />
                </Disclosure>
              </Box>
            ))}
          </Box>
        ))}
      </Container>
    </Box>
  );
};

AllCategories.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape(FaqCategory)).isRequired,
};

export default AllCategories;
